export default __webpack_public_path__ + "adcf1cbaf63dde6cfa78f1f91d5bfca7.jpg";